import Button from "../../components/Button/Button";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "./SentEmails.scss";
import TextEditorReader from "../../components/TextEditorReader/TextEditorReader";
import SentEmailsActions from "../../api/SentEmailsActions";
import PageLayout from "../../components/PageLayout/PageLayout";
import {sentIcon} from "../../components/Icon/Icon";

const SentEmailDetail = () => {
    const [email, setEmail] = useState(null);
    const {id} = useParams();

    useEffect(() => {
        SentEmailsActions.getSentEmail(id, setEmail);
    }, [id]);

    return (
        <PageLayout
            titlePage="Sent Emails"
            titlePageContent={email?.subject}
            icon={sentIcon}
            className='sent-email-detail'
            actions={
                <Button to="/sent-emails" variant="secondary">
                    Back
                </Button>
            }
        >
            {email &&
                <>
                    <div className="header">
                        <p><span>From:</span> {email.sender}</p>
                        <p><span>To:</span> {email.recipient}</p>
                        <p><span>Subject:</span> {email.subject}</p>
                        <p><span>Sent at:</span> {email.sentAt}</p>
                    </div>
                    <hr/>
                    <TextEditorReader text={email.body} className="border"/>
                </>
            }
        </PageLayout>
    );
};

export default SentEmailDetail;
